import { compose, withProps } from 'recompose'
import { OPEN_BV_REVIEWS_TAB_AND_SCROLL_DOWN } from 'constant'
import withBazaarVoiceRatingFromStore from 'components/common/hoc/withBazaarVoiceInlineRatings/withBazaarVoiceRatingFromStore'
import { tabsConfig } from './helpers'
import { REVIEWS_TAB } from './constants'
import TabsTireDetails from './TabsTireDetails'

const withTabsConfig = withProps(({
  reviewsCount, productId
}) => ({
  tabsConfig: tabsConfig(reviewsCount, productId)
}))

export default compose(
  withProps(({ frontTire: { bvId }, bvId: bvIdForRating }) => ({
    productId: bvId || bvIdForRating,
    tabToActivate: REVIEWS_TAB,
    eventName: OPEN_BV_REVIEWS_TAB_AND_SCROLL_DOWN
  })),
  withBazaarVoiceRatingFromStore,
  withTabsConfig
)(TabsTireDetails)
